import { GetterTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { IHomeState } from './home-state.store';
import { ActivityStatus } from '../../common/enums';

export const getters: GetterTree<IRootState, IHomeState> = {
  membersSource: (state: IHomeState) => {
    return state.memberStatistic.data;
  }
  , averageResolutionTime: (state: IHomeState) => {
    return state.ticketStatistic.data.averageResolutionTime;
  }
  , ticketSource: (state: IHomeState) => {
    return state.ticketStatistic.data;
  }
  , isLoading: (state: IHomeState): boolean => {
    return state.memberStatistic.activityStatus === ActivityStatus.Loading
      || state.ticketStatistic.activityStatus === ActivityStatus.Loading;
  },

  isMemberStatisticLoading: (state: IHomeState): boolean => {
    return state.memberStatistic.activityStatus === ActivityStatus.Loading
  },

  isTicketStatisticLoading: (state: IHomeState ) : boolean => {
    return state.ticketStatistic.activityStatus === ActivityStatus.Loading
  }
  , contractorSource: (state: IHomeState) => {
    return state.contractorStatistic.data;
  },
  blockSource: (state: IHomeState) => {
    return state.blockStatistic.data;
  },
  serviceBookSource: (state: IHomeState) => {
    return state.serviceBookStatistic.data;
  },
  IsServiceBookSourceLoading: (state: IHomeState) : boolean=> {
    return state.serviceBookStatistic.activityStatus === ActivityStatus.Loading
    //return state.serviceBookStatistic.data;
  }
}


// WEBPACK FOOTER //
// ./src/store/home/home-getters.store.ts